export default "__VITE_ASSET__BwcUdea2__"